import {DefaultService} from "@/services/DefaultService";
import API from "@/plugins/axios";
import { Espectacular } from "@/models/Espectacular";

class EspectacularService extends DefaultService {
  constructor(url: string) {
    super(url);
  }

  getSolicitudesEspectacularAll(filters: any): Promise<any> {
    let query = new URLSearchParams(filters).toString().replace(/null/g,'');
    return API.get(`${this.url}/?${query}`);
  }

  getSolicitudesEspectacularById(id: number | string): Promise<any> {
    return API.get(`${this.url}/${id}`);
  }

  createSolicitudesEspectacular(data: any): Promise<any> {
    return API.post(`${this.url}`, data);
  }

  updateSolicitudesEspectacular(id: number | string, data: any): Promise<any> {
    return API.request({
      url: `${this.url}/${id}`,
      data: data,
      method: `PUT`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
  }

  deleteSolicitudesEspectacular(id: number | string): Promise<any> {
    return API.delete(`${this.url}/${id}`);
  }

  getDomicilios() {
    return API.get(`${this.url}/getDomicilios`);
  }

  changeStatus(id: number | string, data: any): Promise<any> {
    return API.post(`${this.url}/${id}/changeStatus`, data);
  }

  firmarDocumento(id: number | string, data: any): Promise<any> {
    return API.post(`${this.url}/${id}/firmarDocumento`, data);
  }

  viewDictamenPDF(idEspectacular: number, data: any) {
    let merged = {...data, 'firmado': true};
    return API.request({
        url: `${this.url}/${idEspectacular}/viewDictamenPDF`,
        method: 'POST',
        data: merged,
        responseType: 'blob'
      });
  }

  viewEstadoCuenta(url: any, data: any, type: any, name: string): Promise<any>{
    return API.request({
      url: url,
      data: data,
      method: type,
      responseType: 'blob'
    });
  }
}

export { EspectacularService };